import {useTranslation} from '@/translations/i18n'
import {Content, NoneValue} from '../atoms/Atoms'
import {forwardRef} from 'react'
import {GalleryImageItem} from '@/components/commons/gallery-image-item/GalleryImageItem'
import {Chip} from '@/components/commons/chip/Chip'
import {RemapExperienceForViewOnly} from '@/features/experience-view-only/types'

export const PhotosStep = forwardRef<HTMLDivElement, {experience: RemapExperienceForViewOnly}>(({experience}, ref) => {
    const {t} = useTranslation()
    const gallery = experience.gallery?.images
    return (
        <Content title={t('experience_shell:step_photos')} columns={5} gap={gallery.length > 0 ? 8 : 4} ref={ref}>
            {gallery.length > 0 ? (
                gallery.map(image => (
                    <GalleryImageItem
                        key={image.id}
                        src={image.url}
                        topLeftSlot={
                            image.isCover && (
                                <Chip
                                    label={t('experience_shell:cover')}
                                    variant={'neutral'}
                                    shape={'roundedRectangle'}
                                />
                            )
                        }
                    />
                ))
            ) : (
                <NoneValue>{t('commons:none')}</NoneValue>
            )}
        </Content>
    )
})

PhotosStep.displayName = 'PhotosStep'
